<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 4H1V2.5H15V4ZM15 9H1V7.5H15V9ZM1 14H15V12.5H1V14Z"
      :fill="fill"
    />
  </g>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: true
    }
  }
};
</script>
